/* @flow strict */

import * as React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import SortableItem from './item';
import _ from 'lodash';

type PropsType = {
  items: []
};

const SortableList = (props: PropsType): any => {
  const _random = _.random(0, Date.now());

  const Container = SortableContainer(({ items }: []): React.Element<'div'> => (
    <div className="sortable">
      {items.map((value: any, index: number): React.Element<'div'> => (
        <SortableItem
          key={`item-${_random}-Container-${index}`}
          index={index}
          type={value.type}
          id={value.id}
          data={{
            ...props,
            index
          }}
          label={value.link_label}
        />
      ))}
    </div>
  ));

  return <Container {...props} />;
};

export default SortableList;
